import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Social Fan-out Settings", -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Connect your AI 24/7 first before enabling social fan-out. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Complete setup in the ")
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Portal", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" tab.")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_12 = { class: "form-check form-switch mb-5 mt-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "fanoutOptIn"
}, " Allow my upline team leader to publish content to my connected social accounts ", -1)
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold mb-3" }, "Connect Social Accounts", -1)
const _hoisted_16 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_18 = { class: "d-flex flex-wrap gap-2 mb-5" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Platform"),
    /*#__PURE__*/_createVNode("th", null, "Account"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", null, "AI agent"),
    /*#__PURE__*/_createVNode("th", null, "Team fan-out"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4 text-end" }, "Actions")
  ])
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createVNode("td", {
  colspan: "6",
  class: "ps-4 pe-4 text-muted"
}, " No connected social accounts yet. Use the connect buttons above to link your accounts. ", -1)
const _hoisted_24 = { class: "ps-4 text-capitalize" }
const _hoisted_25 = { class: "d-flex align-items-center gap-3" }
const _hoisted_26 = { class: "badge badge-light-success text-uppercase" }
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "" }, "Use default agent", -1)
const _hoisted_28 = { class: "form-check form-switch mb-0" }
const _hoisted_29 = { class: "pe-4 text-end" }
const _hoisted_30 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_31 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold" }, "Account performance", -1)
const _hoisted_33 = { class: "text-muted fs-8" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Last 7 days (excluding today), compared via AI/247 Social Planner. ")
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_37 = {
  key: 1,
  class: "text-muted fs-7"
}
const _hoisted_38 = { class: "row g-3 mb-5" }
const _hoisted_39 = { class: "border rounded p-3 h-100" }
const _hoisted_40 = { class: "text-muted fs-8 text-uppercase" }
const _hoisted_41 = { class: "fs-3 fw-bold" }
const _hoisted_42 = { class: "mb-5" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "fw-semibold mb-2" }, "Performance over 30 days", -1)
const _hoisted_44 = { class: "d-flex flex-wrap gap-2 mb-3" }
const _hoisted_45 = {
  key: 0,
  class: "text-muted fs-7 py-6 text-center"
}
const _hoisted_46 = {
  key: 1,
  class: "text-muted fs-7 py-6 text-center"
}
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_49 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Account"),
    /*#__PURE__*/_createVNode("th", null, "Platform"),
    /*#__PURE__*/_createVNode("th", null, "Posts"),
    /*#__PURE__*/_createVNode("th", null, "Likes"),
    /*#__PURE__*/_createVNode("th", null, "Comments"),
    /*#__PURE__*/_createVNode("th", null, "Impressions"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Reach")
  ])
], -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createVNode("td", {
  colspan: "7",
  class: "ps-4 pe-4 text-muted"
}, " No stats cached yet. Click Refresh stats to pull from AI 24/7. ", -1)
const _hoisted_52 = { class: "ps-4" }
const _hoisted_53 = { class: "text-capitalize" }
const _hoisted_54 = { class: "pe-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SocialAccountAvatar = _resolveComponent("SocialAccountAvatar")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("h3", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Share.svg" })
                ]),
                _hoisted_4
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          (_ctx.loadError)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                (!_ctx.hasGhlLocation)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7,
                      (_ctx.embedded)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10
                          ], 64))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: "/settings/ai247-portal",
                            class: "fw-bold"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_12, [
                  _withDirectives(_createVNode("input", {
                    id: "fanoutOptIn",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.socialFanoutOptIn = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.saving || !_ctx.hasGhlLocation,
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
                  }, null, 40, ["disabled"]), [
                    [_vModelCheckbox, _ctx.socialFanoutOptIn]
                  ]),
                  _hoisted_13
                ]),
                _createVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.platformOptions, (platform) => {
                      return (_openBlock(), _createBlock("button", {
                        key: platform,
                        type: "button",
                        class: "btn btn-sm btn-light-primary",
                        disabled: !_ctx.hasGhlLocation || _ctx.connectingPlatform === platform,
                        onClick: ($event: any) => (_ctx.connectPlatform(platform))
                      }, [
                        (_ctx.connectingPlatform === platform)
                          ? (_openBlock(), _createBlock("span", _hoisted_17))
                          : _createCommentVNode("", true),
                        _createTextVNode(" Connect " + _toDisplayString(_ctx.formatPlatformLabel(platform)), 1)
                      ], 8, ["disabled", "onClick"]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-light",
                    disabled: _ctx.syncing || !_ctx.hasGhlLocation,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshAccounts()))
                  }, _toDisplayString(_ctx.syncing ? 'Syncing...' : 'Refresh Connected Accounts'), 9, ["disabled"])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("table", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("tbody", null, [
                      (_ctx.socialAccounts.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_22, [
                            _hoisted_23
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.socialAccounts, (account) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: _ctx.accountKey(account)
                        }, [
                          _createVNode("td", _hoisted_24, _toDisplayString(_ctx.formatPlatformLabel(account.platform)), 1),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_25, [
                              _createVNode(_component_SocialAccountAvatar, {
                                avatar: account.avatar,
                                name: account.accountName,
                                "fallback-id": account.accountId
                              }, null, 8, ["avatar", "name", "fallback-id"]),
                              _createVNode("span", null, _toDisplayString(account.accountName || account.accountId), 1)
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("span", _hoisted_26, _toDisplayString(account.status || 'active'), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("select", {
                              class: "form-select form-select-sm",
                              value: account.agentId || '',
                              disabled: _ctx.savingAgentKey === _ctx.accountKey(account),
                              onChange: ($event: any) => (_ctx.saveAccountAgent(account, $event))
                            }, [
                              _hoisted_27,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAgents, (agent) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: agent.id,
                                  value: agent.id
                                }, _toDisplayString(_ctx.agentLabel(agent)), 9, ["value"]))
                              }), 128))
                            ], 40, ["value", "disabled", "onChange"])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_28, [
                              _createVNode("input", {
                                id: 'fanout-' + _ctx.accountKey(account),
                                class: "form-check-input",
                                type: "checkbox",
                                checked: account.fanoutEnabled !== false,
                                disabled: !_ctx.socialFanoutOptIn || _ctx.savingFanoutKey === _ctx.accountKey(account),
                                onChange: ($event: any) => (_ctx.saveAccountFanout(account, $event))
                              }, null, 40, ["id", "checked", "disabled", "onChange"]),
                              _createVNode("label", {
                                class: "form-check-label visually-hidden",
                                for: 'fanout-' + _ctx.accountKey(account)
                              }, " Allow team fan-out for " + _toDisplayString(account.accountName || account.accountId), 9, ["for"])
                            ])
                          ]),
                          _createVNode("td", _hoisted_29, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-light-danger",
                              disabled: _ctx.disconnectingKey === _ctx.accountKey(account),
                              onClick: ($event: any) => (_ctx.disconnectAccount(account))
                            }, _toDisplayString(_ctx.disconnectingKey === _ctx.accountKey(account) ? 'Disconnecting...' : 'Disconnect'), 9, ["disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.hasGhlLocation)
                  ? (_openBlock(), _createBlock("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode("div", null, [
                          _hoisted_32,
                          _createVNode("div", _hoisted_33, [
                            _hoisted_34,
                            (_ctx.statsFetchedAt)
                              ? (_openBlock(), _createBlock("span", _hoisted_35, " Updated " + _toDisplayString(_ctx.formatDate(_ctx.statsFetchedAt)) + ".", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-primary",
                          disabled: _ctx.statsLoading || !_ctx.socialAccounts.length,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadStatistics(true)))
                        }, _toDisplayString(_ctx.statsLoading ? 'Refreshing...' : 'Refresh stats'), 9, ["disabled"])
                      ]),
                      (_ctx.statsError)
                        ? (_openBlock(), _createBlock("div", _hoisted_36, _toDisplayString(_ctx.statsError), 1))
                        : (!_ctx.socialAccounts.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_37, " Connect a social account to see performance stats. "))
                          : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                              _createVNode("div", _hoisted_38, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpiCards, (kpi) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: kpi.key,
                                    class: "col-6 col-md"
                                  }, [
                                    _createVNode("div", _hoisted_39, [
                                      _createVNode("div", _hoisted_40, _toDisplayString(kpi.label), 1),
                                      _createVNode("div", _hoisted_41, _toDisplayString(_ctx.formatMetric(_ctx.statsTotals[kpi.key])), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _createVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode("div", _hoisted_44, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpiCards, (kpi) => {
                                    return (_openBlock(), _createBlock("button", {
                                      key: 'history-' + kpi.key,
                                      type: "button",
                                      class: ["btn btn-sm", _ctx.selectedHistoryMetric === kpi.key ? 'btn-light-primary' : 'btn-light'],
                                      onClick: ($event: any) => (_ctx.selectedHistoryMetric = kpi.key)
                                    }, _toDisplayString(kpi.label), 11, ["onClick"]))
                                  }), 128))
                                ]),
                                (_ctx.historyLoading)
                                  ? (_openBlock(), _createBlock("div", _hoisted_45, " Loading history... "))
                                  : (!_ctx.historyPoints.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_46, " Not enough history yet. Stats are collected hourly. "))
                                    : (_openBlock(), _createBlock(_component_apexchart, {
                                        key: 2,
                                        type: "area",
                                        height: "280",
                                        options: _ctx.chartHistoryOptions,
                                        series: _ctx.chartHistorySeries
                                      }, null, 8, ["options", "series"]))
                              ]),
                              _createVNode("div", _hoisted_47, [
                                _createVNode("table", _hoisted_48, [
                                  _hoisted_49,
                                  _createVNode("tbody", null, [
                                    (_ctx.statsAccounts.length === 0)
                                      ? (_openBlock(), _createBlock("tr", _hoisted_50, [
                                          _hoisted_51
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statsAccounts, (row) => {
                                      return (_openBlock(), _createBlock("tr", {
                                        key: (row.platform || '') + (row.accountId || '')
                                      }, [
                                        _createVNode("td", _hoisted_52, _toDisplayString(row.accountName || row.accountId || '—'), 1),
                                        _createVNode("td", _hoisted_53, _toDisplayString(_ctx.formatPlatformLabel(row.platform)), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.formatMetric(row.metrics?.posts)), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.formatMetric(row.metrics?.likes)), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.formatMetric(row.metrics?.comments)), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.formatMetric(row.metrics?.impressions)), 1),
                                        _createVNode("td", _hoisted_54, _toDisplayString(_ctx.formatMetric(row.metrics?.reach)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 2)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
}